import { ThemeProperties } from '../../../core';

export interface InputSelectTheme {
	triggerColor: string;
	triggerBackground: string;
	triggerPlaceholderColor: string;
	triggerSelectedBackground: string;
	triggerInvalidBackground: string;
	triggerInvalidBorder: string;
	triggerIconColor: string;
	triggerIconSize: string;
	triggerIconGap: string;
	selectIconColor: string;
	contentBackground: string;
	contentBorderRadius: string;
	contentBorderColor: string;
	contentBoxShadow: string;
	itemColor: string;
	itemBorderRadius: string;
	itemHeight: string;
	itemHeightMobile: string;
	itemPadding: string;
	itemPaddingMobile: string;
	itemDisabledColor: string;
	itemDisabledBackground: string;
	itemCheckedFont: string;
	itemCheckedBackground: string;
	itemHighlightBackground: string;
	itemSeparatorBackground: string;
	itemSeparatorSpacing: string;
	itemIndicatorSpacing: string;
	itemIndicatorSpacingMobile: string;
	itemIndicatorColor: string;
	itemScrollButtonColor: string;
	itemViewportPadding: string;
	itemViewportPaddingMobile: string;
}

export const theme = new ThemeProperties('inputSelect');
